import React from "react";
import { Carousel } from "react-bootstrap";
import Image1 from "../../Assets/images/Consdroid.jpg";
import Image2 from "../../Assets/images/Tcube.jpg";
import Image3 from "../../Assets/images/Truprops.jpg";
import Image4 from "../../Assets/Rivazia.jpg";

function Index() {
  const carousalImage = [
    {
      key: 1,
      name: "",
      image: Image1,
    },
    {
      key: 2,
      name: "",
      image: Image2,
    },
    {
      key: 3,
      name: "",
      image: Image3,
    },
  ];
  {
    carousalImage?.map((data) => {
      return;
    });
  }
  return (
    <>
      <Carousel wrap={true}>
        <Carousel.Item interval={2000}>
          <div className="carousel-item-image">
            <img
              className="d-block w-100 carousal-slider-image"
              src={Image3}
              alt="First slide"
            />
          </div>
          <Carousel.Caption></Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item interval={2000}>
          <div className="carousel-item-image">
            <img
              className="d-block w-100 carousal-slider-image"
              src={Image2}
              alt="Second slide"
            />
          </div>
          <Carousel.Caption></Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <div className="carousel-item-image">
            <img
              className="d-block w-100  carousal-slider-image"
              src={Image1}
              alt="Third slide"
            />
          </div>
          <Carousel.Caption></Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <div className="carousel-item-image">
            <img
              className="d-block w-100  carousal-slider-image"
              src={Image4}
              alt="Third slide"
            />
          </div>
          <Carousel.Caption></Carousel.Caption>
        </Carousel.Item>
      </Carousel>
      <div className=""></div>
    </>
  );
}

export default Index;
